import { useEffect, useState } from "react";
import api, { errorMessage } from "@/lib/api";
import { Crown, Trophy, IndianRupee } from "lucide-react";
import { toast } from "sonner";

export default function ReferralLeaderboardCard() {
  const [data, setData] = useState(null);
  const [month] = useState(new Date().toISOString().slice(0,7));
  useEffect(() => {
    api.get(`/admin/referral-leaderboard?month=${month}`).then(r => setData(r.data)).catch(e => toast.error(errorMessage(e)));
  }, [month]);
  const inr = (n) => `₹${Number(n||0).toLocaleString("en-IN")}`;
  const medal = ["🥇","🥈","🥉","4","5"];
  return (
    <div className="card-surface p-6" data-testid="referral-leaderboard-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center"><Crown className="w-5 h-5 text-amber-500"/></div>
          <div>
            <div className="text-xs uppercase tracking-widest text-amber-500 font-bold">Referral Leaderboard</div>
            <div className="font-heading text-lg text-white">Top 5 · {data?.month || month}</div>
          </div>
        </div>
      </div>
      {(!data || data.top.length === 0) ? (
        <div className="text-slate-500 text-sm py-6 text-center">No disbursed referrals in this month yet.</div>
      ) : (
        <div className="space-y-2">
          {data.top.map((r, i) => (
            <div key={r.staff_id} data-testid={`leaderboard-row-${i}`} className="flex items-center justify-between p-3 rounded-lg bg-slate-950/60 border border-white/5">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-lg ${i===0?"bg-amber-500/20 text-amber-400":"bg-slate-800 text-slate-300"} flex items-center justify-center font-bold`}>{medal[i]}</div>
                <div>
                  <div className="text-white text-sm">{r.staff_name}</div>
                  <div className="text-xs text-slate-500">{(r.sub_role || r.staff_role || "").replace("_"," ")}</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-amber-400 font-mono-alt text-sm font-bold">{inr(r.total_bonus)}</div>
                <div className="text-xs text-slate-500">{r.cases} case{r.cases>1?"s":""} · {inr(r.total_disbursed)} disbursed</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
